<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </div>

    <v-toolbar flat color="white">
      <v-toolbar-title>Users</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on"
            ><v-icon>add</v-icon>&nbsp; New User</v-btn
          >
        </template>
        <v-card v-if="isAllowedNewAdmin() || editedIndex !== -1">
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.name"
                      label="User Name"
                      :roles="validate_rule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.email"
                      :roles="validate_rule"
                      label="Email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="editedItem.client_id"
                      :items="indexData.clients"
                      label="select a company"
                      item-text="name"
                      item-value="id"
                      :roles="validate_rule"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.password"
                      :type="show1 ? 'text' : 'password'"
                      @click:append="show1 = !show1"
                      :append-icon="show1 ? 'visibility' : 'visibility_off'"
                      :rules="passwordRules"
                      label="Password"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <span class="headline">Admin creation limit exceed</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <p>Please subscribe premium or corporate package</p>
                <br />
                <router-link
                  style="text-decoration: none"
                  to="/subscription-package"
                  ><p>click here to go to subscription page</p></router-link
                >
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.users"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">{{ props.item.client_id }}</td>
        <!-- <td class="text-xs-center">{{ props.item.password }}</td> -->
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)"> delete </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import utilities from "../../api/utilities.js";

export default {
  data: () => ({
    dialog: false,
    show1: false,
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    search: "",
    apiUrl: "official-user",
    valid: true,
    headers: [
      {
        text: "Serial No",
        align: "center",
        value: "serial_no",
        sortable: false,
      },
      { text: "Name", align: "center", value: "name", sortable: true },
      { text: "Email", align: "center", value: "email", sortable: true },
      {
        text: "Client_id",
        align: "center",
        value: "client_id",
        sortable: true,
      },
      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      email: "",
      password: "",
      client_id: "",
    },
    defaultItem: {
      name: "",
      email: "",
      password: "",
      client_id: "",
    },
    validate_rule: [(v) => !!v || "This field is required"],
    passwordRules: [
      (v) => !!v || "password is required",
      (v) => (v && v.length > 5) || "minimum 6 characters",
    ],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "New Official User"
        : "Edit Official User";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.indexData.users.indexOf(item);
      var result =
        confirm("Are you sure you want to delete this item?") &&
        this.indexData.users.splice(index, 1);
      if (result) {
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
        this.initialize();
      }
    },

    isAllowedNewAdmin() {
      if (this.indexData.users) {
        if (
          Object.keys(this.indexData.users).length <
          utilities.allowedNumberOfAdmin(
            this.subscriptionData.subscriptionFeatures
          )
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },

    validate() {
      if (this.editedItem.password) {
        return (this.show1 = true);
      } else {
        this.show1 = false;
      }

      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        } else {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        }
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>
